const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "auth_token";
let onUnauthorized = null;

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
export const setUnauthorizedHandler = (fn) => { onUnauthorized = fn; };

async function errorOf(res) {
  let msg = `Terjadi kesalahan (${res.status})`;
  try { const j = await res.json(); if (typeof j.detail === "string") msg = j.detail; } catch {}
  const e = new Error(msg);
  e.status = res.status;
  return e;
}

export async function api(path, opts = {}) {
  const t = getToken();
  const res = await fetch(`${BASE}/api${path}`, {
    ...opts,
    headers: { ...(opts.body instanceof FormData ? {} : { "Content-Type": "application/json" }), ...(t ? { Authorization: `Bearer ${t}` } : {}), ...(opts.headers || {}) },
  });
  if (res.status === 401 && path !== "/auth/password/login") {
    setToken(null);
    onUnauthorized?.();
    throw new Error("Sesi berakhir, silakan login kembali");
  }
  if (!res.ok) throw await errorOf(res);
  return res.json();
}

export const post = (path, body) => api(path, { method: "POST", body: JSON.stringify(body ?? {}) });
export const put = (path, body) => api(path, { method: "PUT", body: JSON.stringify(body ?? {}) });
export const del = (path) => api(path, { method: "DELETE" });
export const fileUrl = (p) => `${BASE}/api/files/${p}?token=${encodeURIComponent(getToken() || "")}`;
export const publicFileUrl = (p) => `${BASE}/api/public/files/${p}`;
export const absUrl = (p) => (p ? `${BASE}${p}` : null);
export const APP_LINK = typeof window !== "undefined" ? window.location.origin : "";

export async function download(path, name) {
  const res = await fetch(`${BASE}/api${path}`, { headers: { Authorization: `Bearer ${getToken()}` } });
  if (!res.ok) throw await errorOf(res);
  const url = URL.createObjectURL(await res.blob());
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  a.click();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
  return `${name} diunduh`;
}

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append("file", file);
  return (await api("/upload", { method: "POST", body: fd })).path;
}

export async function uploadVideo(file, onProgress, cancel) {
  const init = await post("/uploads/init", { name: file.name, size: file.size, mime: file.type });
  for (let i = 0; i < init.total_chunks; i++) {
    if (cancel?.cancelled) throw new Error("Unggahan dibatalkan");
    const chunk = file.slice(i * init.chunk_size, (i + 1) * init.chunk_size);
    const res = await fetch(`${BASE}/api/uploads/${init.upload_id}/${i}`, { method: "PUT", body: chunk, headers: { Authorization: `Bearer ${getToken()}` } });
    if (!res.ok) throw await errorOf(res);
    onProgress?.((i + 1) / init.total_chunks);
  }
  return (await post(`/uploads/${init.upload_id}/complete`)).path;
}
